import { assign, get } from "utils/lodash";

const _localConfig = {
  GRAPHQL_URL: process.env.NEXT_PUBLIC_GRAPHQL_URL,
};
const configProvider = {
  get: (path: any) => {
    return get(_localConfig, path);
  },
  set: (config: any) => {
    assign(_localConfig, config);
  },
};
export default configProvider;
